<template>
  <div class="compete-rules card flex-column">
    <div class="section">
      <base-section-title title="竞价规则" class="section-title" />

      <!--    规则表格-->
      <div class="compete-rules-content">
        <el-table
          border
          highlight-current-row
          style="width: 100%"
          header-row-class-name="table-header"
          :data="rulesList"
          size="medium"
        >
          <el-table-column label="类型" prop="type" min-width="2" />
          <el-table-column label="内容" prop="value" min-width="3">
            <template slot-scope="{ row }">
              <span>
                {{ row.isMoney ? strToThousands(row.money) : row.value }}
              </span>
              <money-in-cn v-if="row.isMoney" :money="row.money" />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="section flex-column chat-content">
      <div class="section-title">
        <base-section-title title="项目发起人" />
        <el-button
          v-if="hasNewChat"
          type="text"
          class="text-warning new-chat-mes"
          size="small"
          @click="moveChatMesBottom"
        >有新消息</el-button>
      </div>
    </div>

    <div class="chat-mes-wrap section-content">
      <el-scrollbar ref="chatWrap">
        <div class="chat-mes-list">
          <div
            v-for="chat in chatMesList"
            :key="chat.sendTime"
            class="chat-mes"
          >
            <p class="send-mes-time">{{ chat.sendTime }}</p>
            <p class="send-person-name">{{ chat.sender }}：</p>
            <div class="chat-bubble">
              <div class="send-mes-content">{{ chat.content }}</div>
            </div>
          </div>
        </div>
      </el-scrollbar>

      <div v-if="!chatMesList.length" class="chat-no-content flex-center">
        暂无相关数据
      </div>
    </div>
  </div>
</template>

<script>
// 组件
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import MoneyInCn from '@/components/common/MoneyInCn'

// 进入滚动函数
import { scrollMainTo } from '@/utils/scroll-to'
import { strToThousands } from '@/utils/utils'
// 数据字典
import { competeRequireTaxDict } from '@/dictionary/project/compete'

export default {
  name: 'CompeteRules',

  components: { BaseSectionTitle, MoneyInCn },

  props: {
    chatMesList: {
      type: Array,
      default: () => []
    },

    rules: {
      type: Object,
      require: true
    },

    ratio: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      hasNewChat: false,
      chatWrapHeight: 0
    }
  },

  computed: {
    rulesList() {
      return [
        { type: '竞价开始时间', value: this.rules.offerStartTime },
        { type: '竞价时长', value: this.rules.competitionTime + '分' },
        { type: '超时竞价延长', value: this.rules.extendTime + '分' },
        {
          type: '报价最小幅度',
          value: this.rules.offerRange,
          isMoney: true,
          money: this.rules.offerRange
        },
        {
          type: '报价是否含税',
          value:
            competeRequireTaxDict.translate(this.rules.whetherTax).label || '-'
        },
        { type: '报价次数', value: '无限制' },
        {
          type: '是否公开竞价',
          value: this.rules.openCompany ? '公开' : '不公开'
        },
        {
          type: '竞价方式',
          value: this.rules.competitionMethod ? '竞高价' : '竞低价'
        },
        {
          type: '起始价',
          value: this.rules.offerStartAmount + '元',
          isMoney: true,
          money: this.rules.offerStartAmount
        }
      ]
    }
  },

  watch: {
    chatMesList(val) {
      this.keepChatMesBottom()
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.chatWrapHeight = document.querySelector(
        '.chat-mes-wrap'
      ).clientHeight
      this.keepChatMesBottom(true)
    })
  },

  methods: {
    strToThousands,

    // 滚动消息保持在最底部，当用于向上滚动了100px，则不再保持在最底部
    keepChatMesBottom(once = false) {
      const scrollHeight = this.$refs.chatWrap.wrap.scrollHeight
      const scrollTop = this.$refs.chatWrap.wrap.scrollTop

      if (
        scrollHeight - scrollTop - this.chatWrapHeight >= 100 * this.ratio &&
        !once
      ) {
        this.hasNewChat = true
        return
      }

      scrollMainTo(this.$refs.chatWrap.wrap, scrollHeight, 500)
    },

    // 点击新消息提示，回到底部的函数
    moveChatMesBottom() {
      this.hasNewChat = false

      scrollMainTo(
        this.$refs.chatWrap.wrap,
        this.$refs.chatWrap.wrap.scrollHeight,
        500
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.compete-rules {
  flex: 1;

  .new-chat-mes {
    position: absolute;
    top: 0;
    right: 0;
    margin-right: pixel-to-rem($n: 20);
  }

  .compete-rules-content {
    margin: 0 pixel-to-rem($n: 20);
  }

  .chat-content {
    margin: 0;
    .section-title {
      margin: 0;
    }
  }

  .chat-mes-wrap {
    position: relative;
    flex: 1;
    margin: 0 pixel-to-rem($n: 20);
    background-color: $grey-background-color;
    overflow: hidden;

    ::v-deep .el-scrollbar {
      height: 100%;

      .el-scrollbar__wrap {
        overflow-x: hidden !important;
      }
    }

    .chat-mes-list {
      padding: 0 pixel-to-rem($n: 20);

      .chat-mes {
        margin-bottom: pixel-to-rem($n: 20);

        .send-person-name {
          font-size: pixel-to-rem($n: 20);
          margin: pixel-to-rem($n: 10) 0;
        }
        .send-mes-content {
          display: inline-block;
          padding: pixel-to-rem($n: 12);
          background-color: $primary-color;
          color: $white-color;
          font-size: pixel-to-rem($n: 20);
          word-break: break-all;
          border-radius: pixel-to-rem($n: 10) pixel-to-rem($n: 4)
            pixel-to-rem($n: 10) pixel-to-rem($n: 4);
        }
        .send-mes-time {
          text-align: center;
          font-size: pixel-to-rem($n: 16);
          color: $second-text-color;
          margin: pixel-to-rem($n: 10) 0;
        }
      }
    }

    .chat-no-content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      font-size: pixel-to-rem($n: 22);
      color: $third-text-color;
    }
  }
}
</style>
